import styled from 'styled-components';
import { DialogMixin } from '../../mixins/components/DialogMixin';
export var StyledDialog = /*#__PURE__*/styled.section.withConfig({
  displayName: "StyledDialog",
  componentId: "c11n-8-107-0__sc-11wyxbm-0"
})(["", ""], DialogMixin);